import React from 'react';

const SuperTag = ({ children, ...rest }) => {
  return (
    <label
      className="superTag"
      dangerouslySetInnerHTML={{ __html: children }}
      {...rest}
    />
  );
};

export default SuperTag;
